// NGRX
import { Action } from '@ngrx/store';
import { Update } from '@ngrx/entity';
// CRUD
import { Link } from '../_models/link.model';
// Models
import { QueryParamsModel } from '../../_base/crud';

export enum LinkActionTypes {
  LinksPageRequested = '[Links] Links Page Requested',
  LinksPageLoaded = '[Links] Links Page Loaded',
  LinksRequested = '[Links] Links Requested',
  LinksLoaded = '[Links] Links Loaded',
  LinksPageCancelled = '[Links] Links Page Cancelled',
  LinkOnServerCreated = '[Links] Link On Server Created',
  LinkOnServerUpdated = '[Links] Link On Server Updated',
  LinkOnServerDeleted = '[Links] Link On Server Deleted',
  ThrowLinkError = '[Links] Throw Error',
  FireLinkSuccess = '[Links] Fire Success',
  LinksPageToggleLoading = '[Links] Links Page Toggle Loading',
}

export class LinkOnServerCreated implements Action {
  readonly type = LinkActionTypes.LinkOnServerCreated;
  constructor(public payload: { body: any }) {}
}

export class ThrowLinkError implements Action {
  readonly type = LinkActionTypes.ThrowLinkError;
  constructor(public payload: { error: any }) {}
}

export class FireLinkSuccess implements Action {
  readonly type = LinkActionTypes.FireLinkSuccess;
  constructor(public payload: { action_type: string }) {}
}

export class LinkOnServerUpdated implements Action {
  readonly type = LinkActionTypes.LinkOnServerUpdated;
  constructor(
    public payload: {
      partialLink: Update<Link>;
      link: Link;
    },
  ) {}
}

export class LinkOnServerDeleted implements Action {
  readonly type = LinkActionTypes.LinkOnServerDeleted;
  constructor(public payload: { id: number }) {}
}

export class LinksPageRequested implements Action {
  readonly type = LinkActionTypes.LinksPageRequested;
  constructor(public payload: { page: QueryParamsModel }) {}
}

export class LinksPageLoaded implements Action {
  readonly type = LinkActionTypes.LinksPageLoaded;
  constructor(public payload: { links: Link[]; totalCount: number; page: QueryParamsModel }) {}
}

export class LinksRequested implements Action {
  readonly type = LinkActionTypes.LinksRequested;
}

export class LinksLoaded implements Action {
  readonly type = LinkActionTypes.LinksLoaded;
  constructor(public payload: { links: Link[] }) {}
}

export class LinksPageCancelled implements Action {
  readonly type = LinkActionTypes.LinksPageCancelled;
}

export class LinksPageToggleLoading implements Action {
  readonly type = LinkActionTypes.LinksPageToggleLoading;
  constructor(public payload: { isLoading: boolean }) {}
}

export type LinkActions =
  | LinkOnServerCreated
  | LinkOnServerUpdated
  | LinkOnServerDeleted
  | LinksPageRequested
  | LinksPageLoaded
  | LinksRequested
  | LinksLoaded
  | LinksPageCancelled
  | LinksPageToggleLoading
  | ThrowLinkError
  | FireLinkSuccess;
